import { render, staticRenderFns } from "./LbsMemberList.vue?vue&type=template&id=dd42a17a&"
import script from "./LbsMemberList.vue?vue&type=script&lang=js&"
export * from "./LbsMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports